import { heroTicker, latestArticles, portalStats, siteMeta } from "@/mocks/news";

export default function Hero() {
  const preview = latestArticles.slice(0, 3);

  return (
    <>
      <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20editorial%20background%20with%20deep%20crimson%20amber%20and%20dark%20green%20painterly%20shapes%20on%20ink%20black%20paper%20texture%2C%20dramatic%20directional%20lighting%2C%20strong%20dark%20negative%20space%20for%20text%2C%20grainy%20cinematic%20magazine%20cover%20aesthetic%2C%20no%20people&width=1600&height=900&seq=gua-hero-bg-01&orientation=landscape"
            alt="瓜田爆料资讯门户抽象编辑视觉背景"
            className="h-full w-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/60 to-primary-950/55" />

        <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 pb-14 pt-28 md:px-8 md:pb-20 md:pt-40">
          <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-50 backdrop-blur">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-400" />
                独家首发 · 第一手 · 内部流出
              </span>

              <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-[56px]">
                {siteMeta.name}
                <span className="mt-2 block text-xl font-bold text-secondary-300 md:text-2xl lg:text-3xl">
                  最新动静不过夜
                </span>
              </h1>

              <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
                {siteMeta.description}
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#featured"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-flashlight-line text-base" aria-hidden />
                  看今日首发
                </a>
                <a
                  href="#subscribe"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-notification-3-line text-base" aria-hidden />
                  订阅首发推送
                </a>
              </div>
            </div>

            <aside className="lg:col-span-5">
              <div className="rounded-lg border border-background-50/20 bg-background-50/10 p-5 backdrop-blur">
                <div className="flex items-center justify-between">
                  <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-background-50">
                    <i className="ri-radar-line text-primary-300" aria-hidden />
                    首发速览
                  </h2>
                  <a href="#latest" className="text-xs text-background-100/70 hover:text-secondary-300">
                    全部 →
                  </a>
                </div>
                <ul className="mt-4 flex flex-col divide-y divide-background-50/10">
                  {preview.map((item) => (
                    <li key={item.id} className="flex gap-3 py-3 first:pt-0 last:pb-0">
                      <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded bg-primary-500 text-[11px] font-bold text-background-50">
                        {item.publishedAt.replace(/[^0-9]/g, "").slice(0, 2) || "新"}
                      </span>
                      <a href="#latest" className="text-sm leading-snug text-background-50/90 hover:text-secondary-300">
                        {item.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="mt-3 text-xs text-background-100/60">
                更新时间以页面顶部第一条为准，反转会写回同一条时间线
              </p>
            </aside>
          </div>

          <dl className="mt-12 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-8 md:grid-cols-4 md:gap-6">
            {portalStats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-background-100/60">{stat.label}</dt>
                <dd className="mt-1.5 font-heading text-2xl font-black text-background-50 md:text-3xl">
                  {stat.value}
                  <span className="ml-1 text-sm font-medium text-secondary-300">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section aria-label="最新首发滚动" className="w-full bg-foreground-950">
        <div className="marquee-mask flex items-center gap-4 overflow-hidden border-y border-background-50/10 py-3">
          <span className="ml-4 hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 md:flex">
            <i className="ri-broadcast-line" aria-hidden />
            正在滚动
          </span>
          <div className="flex w-max animate-marquee items-center">
            {[...heroTicker, ...heroTicker].map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="flex items-center gap-3 whitespace-nowrap px-6 text-sm text-background-100/80"
              >
                <i className="ri-flashlight-fill text-secondary-400" aria-hidden />
                {text}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}